import { observable, makeObservable } from 'mobx';
export class RecommendationProfileStore {
    constructor(services, data) {
        this.display = {};
        this.type = 'default';
        if (!data?.profile?.tag) {
            return;
        }
        this.tag = data.profile.tag;
        this.placement = data.profile.placement;
        this.display = data.profile.display;
        this.type = data.profile.display.template.type;
        makeObservable(this, {
            tag: observable,
            placement: observable,
            display: observable,
            type: observable,
        });
    }
}
